import React, { Component } from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import styled, { css } from "styled-components";

const StyledSelect = styled(ReactSelect)`  
  .Select-value-label, .Select-option {
    color: ${props => css`${props.styled && props.styled.color} !important`}
  }
}`;

export default class Select extends Component {
  state = {
    selectedTimeslot: this.getDefaultOption(),
    prevSelectedTimeslot: this.getDefaultOption(),
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!newProps.value) {
      const value = this.getDefaultOption(newProps)
      this.setState({ selectedTimeslot: value })
      this.props.onChange(value)
    } else {
      this.setState({ selectedTimeslot: newProps.value })
    }
  }

  getDefaultOption(props = this.props) {
    const options = props.options.filter(x => !x.disabled)
    if (this.props.allowSelectOption) {
      return '';
    }
    return options.length > 0 ? options[0].value : ''
  }

  onChange(data) {
    const { onChange } = this.props;
    const { selectedTimeslot: previousSelected } = this.state;
    const value = data ? data.value : null;
    this.setState({ prevSelectedTimeslot: previousSelected, selectedTimeslot: value });
    onChange(value);
  }

  // Reset select to previous selected value.
  onResetToPrev() {
    const { onResetToPrev } = this.props;
    const { prevSelectedTimeslot } = this.state;
    this.setState({
      selectedTimeslot: prevSelectedTimeslot,
    });
    onResetToPrev();
  }

  value() {
    return this.props.options.find(option => option.value == this.state.selectedTimeslot)
  }

  render() {
    return (
      <StyledSelect
        {...this.props}
        id={`split-button-basic-${0}`}
        value={this.value()}
        onChange={this.onChange.bind(this)}
        onResetToPrev={this.onResetToPrev.bind(this)}
        />
    );
  }
}

Select.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
};
